"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.copyAllFlowVersionCollections = exports.deleteCollection = exports.copyCollection = void 0;
const firestore_1 = require("firebase/firestore");
const copyCollection = async ({ sourceRef, targetRef, collectionPath, subcollectionPaths, filterDocsFunction, }, batch) => {
    const query = (0, firestore_1.collection)(sourceRef, collectionPath);
    const { docs } = await (0, firestore_1.getDocs)(query);
    if (docs.length) {
        await Promise.all(docs.map(async (d) => {
            const docData = d.data();
            if (docData && (!filterDocsFunction || filterDocsFunction(d))) {
                const targetRefDocRef = (0, firestore_1.doc)(targetRef, collectionPath, d.id);
                batch.set(targetRefDocRef, docData);
                if (subcollectionPaths) {
                    await Promise.all(subcollectionPaths.map(async (subcollectionPath) => {
                        await (0, exports.copyCollection)({
                            sourceRef: d.ref,
                            targetRef: targetRefDocRef,
                            collectionPath: subcollectionPath,
                        }, batch);
                    }));
                }
            }
        }));
    }
};
exports.copyCollection = copyCollection;
const deleteCollection = async ({ ref, collectionPath, subcollectionPaths, }, batch) => {
    const query = (0, firestore_1.collection)(ref, collectionPath);
    const { docs } = await (0, firestore_1.getDocs)(query);
    if (docs.length) {
        await Promise.all(docs.map(async (d) => {
            await batch.delete(d.ref);
            if (subcollectionPaths) {
                await Promise.all(subcollectionPaths.map(async (subcollectionPath) => {
                    await (0, exports.deleteCollection)({
                        ref: d.ref,
                        collectionPath: subcollectionPath,
                    }, batch);
                }));
            }
        }));
    }
};
exports.deleteCollection = deleteCollection;
const copyAllFlowVersionCollections = async ({ sourceRef, targetRef, filterStepsFunction, filterWebhooksFunction, }, batch) => {
    await (0, exports.copyCollection)({
        sourceRef,
        targetRef,
        collectionPath: 'triggers',
    }, batch);
    await (0, exports.copyCollection)({
        sourceRef,
        targetRef,
        collectionPath: 'steps',
        filterDocsFunction: filterStepsFunction,
    }, batch);
    await (0, exports.copyCollection)({
        sourceRef,
        targetRef,
        collectionPath: 'webhooks',
        filterDocsFunction: filterWebhooksFunction,
        subcollectionPaths: ['private'],
    }, batch);
    await (0, exports.copyCollection)({
        sourceRef,
        targetRef,
        collectionPath: 'assets',
    }, batch);
    await (0, exports.copyCollection)({
        sourceRef,
        targetRef,
        collectionPath: 'statusLog',
    }, batch);
};
exports.copyAllFlowVersionCollections = copyAllFlowVersionCollections;
//# sourceMappingURL=domain-utils.js.map